<template>
  <div class="p-5 rounded-md shadow-md border">
      <slot></slot>
  </div>
</template>